import { Textarea } from "@component/textarea";
import { useEffect, useState } from "react";

interface Props {
  isEditing: boolean;
  data: string;
  onChange: (values: string) => void;
}

export function ProfessionalSummary(props: Props) {
  const [summary, setSummary] = useState<string>();

  const handleSummarChange = (value: string) => {
    setSummary(value);
  };

  useEffect(() => {
    setSummary(props.data);
  }, [props.data]);

  useEffect(() => {
    if (summary) {
      props.onChange(summary);
    }
  }, [summary]);

  return (
    <>
      <p className="text-gray-700 mt-1 text-sm mb-6">
        Your summary is auto-generated from your resume and professionally refined using AI for employers. You can still edit it anytime.
      </p>

      {props.isEditing ? (
        <div className="space-y-4 flex-grow">
          <div className="h-full">
            <label className="text-sm text-black mb-1 block">
              Professional Summary
            </label>
            <Textarea
              value={summary || ""}
              className="border-gray-300 text-black"
              rows={10}
              onChange={(e) => handleSummarChange(e.target.value || "")}
              placeholder="Enter your professional summary. Use double line breaks to separate paragraphs."
            />
          </div>
        </div>
      ) : (
        <div className="flex flex-col flex-grow">
          {summary === "" ? (
            <p className="text-lg text-gray-400 italic">
              Upload your resume to automatically generate a professional summary. You may only manually add or edit after successful upload.
            </p>
          ) : (
            <p className="text-black leading-relaxed text-lg">
              {summary}
            </p>
          )}
        </div>
      )}
    </>
  );
}
